<template>
  <div class="yxtbiz-inspection-selector">
    <div class="yxtbiz-inspection-selector__left">
      <div class="yxtbiz-inspection-selector__filter clearfix font-size-14">
        <yxt-popover
          :append-to-body="false"
          popper-class="yxtbiz-inspection-selector__popover"
          placement="bottom-start"
          :visible-arrow="false"
          v-model="showMoreFilter"
        >
          <yxt-button slot="reference" plain class="yxtbiz-filter-btn mr12">
            <yxt-svg
              width="20px"
              height="20px"
              icon-class="filter"
              class="v-top"
            />
            <span class="ml8 v-top">{{
              $t('pc_biz_common_lbl_moreFilter' /* 更多筛选 */)
            }}</span>
            <i
              class="ml8"
              :class="
                showMoreFilter ? 'yxt-icon-arrow-up' : 'yxt-icon-arrow-down'
              "
            ></i>
          </yxt-button>
          <yxt-form :inline="true">
            <yxt-row :gutter="20">
              <yxt-col :span="12">
                <yxt-form-item
                  label-width="100px"
                  :label="$t('pc_biz_shoptour_publish_time').d('任务发布时间')"
                >
                  <yxt-date-picker
                    @change="changeDate"
                    v-model="publishDate"
                    format="yyyy-MM-dd"
                    type="daterange"
                    :range-separator="$t('pc_biz_shoptour_lbl_to').d('至')"
                    :start-placeholder="$t('pc_biz_shoptour_lbl_starttime').d('开始日期')"
                    :end-placeholder="$t('pc_biz_shoptour_lbl_endtime').d('结束日期')"
                  >
                  </yxt-date-picker>
                </yxt-form-item>
              </yxt-col>
              <yxt-col :span="12">
                <yxt-form-item
                  label-width="100px"
                  :label="$t('pc_biz_shoptour_plan_type').d('任务类型')"
                >
                  <yxt-select
                    v-model="inspectionSearch.types"
                    multiple
                    clearable
                    size="large"
                    :placeholder="$t('pc_biz_shoptour_please_select').d('请选择')"
                    @change="changeStatus"
                  >
                    <yxt-option
                      v-for="(value, key) in typeList"
                      :key="value"
                      :label="value"
                      :value="key"
                    ></yxt-option>
                  </yxt-select>
                </yxt-form-item>
              </yxt-col>
            </yxt-row>
            <yxt-row class="mt20" :gutter="20">
              <yxt-col :span="12">
                <yxt-form-item
                  label-width="100px"
                  :label="$t('pc_biz_shoptour_start_time').d('任务开始时间')"
                >
                  <yxt-date-picker
                    @change="changeDate"
                    v-model="startDate"
                    format="yyyy-MM-dd"
                    type="daterange"
                    :range-separator="$t('pc_biz_shoptour_lbl_to').d('至')"
                    :start-placeholder="$t('pc_biz_shoptour_lbl_starttime').d('开始日期')"
                    :end-placeholder="$t('pc_biz_shoptour_lbl_endtime').d('结束日期')"
                  >
                  </yxt-date-picker>
                </yxt-form-item>
              </yxt-col>
              <yxt-col :span="12">
                <yxt-form-item
                  label-width="100px"
                  :label="$t('pc_biz_shoptour_planstatus').d('任务状态')"
                >
                  <yxt-select
                    v-model="inspectionSearch.status"
                    clearable
                    size="large"
                    :placeholder="$t('pc_biz_shoptour_please_select').d('请选择')"
                    @change="changeStatus"
                  >
                    <yxt-option
                      v-for="item in statusList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></yxt-option>
                  </yxt-select>
                </yxt-form-item>
              </yxt-col>
            </yxt-row>
            <yxt-row class="mt20" :gutter="20">
              <yxt-col :span="12">
                <yxt-form-item
                  label-width="100px"
                  :label="$t('pc_biz_shoptour_end_time').d('任务结束时间')"
                >
                  <yxt-date-picker
                    @change="changeDate"
                    v-model="endDate"
                    format="yyyy-MM-dd"
                    type="daterange"
                    :range-separator="$t('pc_biz_shoptour_lbl_to').d('至')"
                    :start-placeholder="$t('pc_biz_shoptour_lbl_starttime').d('开始日期')"
                    :end-placeholder="$t('pc_biz_shoptour_lbl_endtime').d('结束日期')"
                  >
                  </yxt-date-picker>
                </yxt-form-item>
              </yxt-col>
            </yxt-row>
          </yxt-form>
        </yxt-popover>
        <yxt-input
          style="width: 208px"
          :placeholder="$t('pc_biz_shoptour_search_by_name').d('请输入任务名称')"
          v-model="inspectionSearch.searchKey"
          searchable
          @search="examNameSearch"
          maxlength="100"
        >
        </yxt-input>
      </div>
      <div class="yxtbiz-inspection-selector__main mt16">
        <yxt-table
          :ref="refTable"
          class="yxtbiz-inspection-selector__table"
          v-loading="loading"
          :data="inspectionList"
          :height="tableHeight"
          @select-all="selectAll"
          @select="select"
          :default-sort="{ prop: 'releaseTime', order: 'desc' }"
          @sort-change="sortChange"
        >
          <yxt-table-column
            type="selection"
            :show-overflow-tooltip="false"
            width="30"
            align="right"
            clear-padding="left-right"
          ></yxt-table-column>
          <yxt-table-column
            show-overflow-tooltip
            :label="$t('pc_biz_shoptour_planname').d('任务名称')"
            prop="name"
            align="left"
            min-width="80"
          >
          </yxt-table-column>
          <yxt-table-column
            show-overflow-tooltip
            :label="$t('pc_biz_shoptour_plan_type').d('任务类型')"
            prop="type"
            align="left"
            min-width="80"
          >
            <template slot-scope="scope">
              <span>
                {{ typeList[scope.row.type] }}
              </span>
            </template>
          </yxt-table-column>
          <yxt-table-column
            show-overflow-tooltip
            :label="$t('pc_biz_shoptour_status').d('状态')"
            prop="status"
            align="left"
            min-width="70"
          >
            <template slot-scope="scope">
              <span
                :class="[
                  'yxtbiz-inspection-selector__status',
                  `yxtbiz-inspection-selector__status--${scope.row.status}`
                ]"
              ></span>
              <span>{{ getStatusName(scope.row.status) }}</span>
            </template>
          </yxt-table-column>
          <yxt-table-column
            :label="$t('pc_biz_shoptour_publish_person').d('发布人')"
            show-overflow-tooltip
            popover-html
            prop="releaseUserName"
            align="left"
            width="100"
          >
            <template slot-scope="scope">
              <yxtbiz-user-name :name="scope.row.releaseUserName" />
            </template>
          </yxt-table-column>
          <yxt-table-column
            show-overflow-tooltip
            :label="$t('pc_biz_shoptour_task_publish_time').d('发布时间')"
            prop="releaseTime"
            sortable="custom"
            :formatter="shortDate"
            align="left"
            width="160"
          ></yxt-table-column>
        </yxt-table>
      </div>
      <yxt-row align="middle" class="yxtbiz-inspection-selector__mask mt16" type="flex">
        <yxt-row type="flex" align="middle" class="col-flex-1">
          <yxt-button
            v-if="showFilterAll"
            type="text"
            class="lh32 yxtbiz-inspection-selector__btn-search-all"
            :class="isSearchAll ? 'color-primary-4 disabled' : ''"
            @click="searchAll"
          >
            {{
              isCancelSelect
                ? $t('pc_biz_shoptour_btn_cancelFilter' /*取消筛选结果*/)
                : $t('pc_biz_shoptour_all_filter_results' /*全选筛选结果*/)
            }}
          </yxt-button>
          <div v-loading="isSearchAll" class="yxtbiz-inspection-selector__loading__all" />
        </yxt-row>
        <yxt-pagination
          :page-size="inspectionSearch.limit"
          :total="count"
          :current-page.sync="page"
          @current-change="pageChange"
          layout="total, prev, pager, next"
          :simple-total="false"
          :page-count="totalPage"
        ></yxt-pagination>
      </yxt-row>
    </div>
    <div class="yxtbiz-inspection-selector__right">
      <div class="yxtbiz-inspection-selector__right_count">{{$t('pc_biz_shoptour_select_info' /*已选择（{0}/{1}）*/, [selectedList.length, maxCount]).d(`已选择（${selectedList.length}/${maxCount}`)}}</div>
      <div style="height: 100%">
        <yxtbiz-virtual-list
          is-scrollbar
          style="height: 100%;overflow: hidden;"
          :data-sources="selectedList"
          data-key="id"
          :estimate-size="32"
          :keeps="50"
          item-tag="div"
        >
          <template slot-scope="{ source }">
            <yxt-tag
              @close="deleteItem(source)"
              size="small"
              type="info"
              class="mb5 tag"
              closable
              :key="source.id"
            >
              <span class="yxtbiz-user-selector-tag">{{ source.name }}</span>
            </yxt-tag>
          </template>
        </yxtbiz-virtual-list>
      </div>
      <yxt-button
        type="text"
        class="yxtbiz-user-clear font-size-12 color-gray-9 hover-primary-6"
        @click="clear"
        :disabled="Object.values(this.selected).length === 0"
        >{{ $t('pc_biz_shoptour_clear_all') }}</yxt-button
      >
    </div>
  </div>
</template>

<script>
import { getInspectionList } from './service';
import resizeTable from '../mixins/resizeTable';
import dateUtil from 'yxt-biz-pc/src/utils/date';
import { Table, TableColumn, Pagination } from 'yxt-pc';
export default {
  name: 'YxtbizInspectionSelector',
  components: {
    YxtPagination: Pagination,
    YxtTable: Table,
    YxtTableColumn: TableColumn
  },
  mixins: [resizeTable],
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      }
    },
    maxCount: { // 选择任务数量限制
      type: Number,
      default: 1000
    },
    // 每页限制条数
    limit: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      refTable: 'stb',
      showMoreFilter: false,
      tableHeight: 0,
      page: 1,
      publishDate: [], // 发布时间
      startDate: [], // 开始时间
      endDate: [], // 结束时间
      inspectionList: [],
      // 来源
      statusList: [
        {
          value: '1',
          label: this.$t('pc_biz_shoptour_lbl_published').d('已发布')
        },
        {
          value: '2',
          label: this.$t('pc_biz_shoptour_lbl_finished').d('已完成')
        }
      ],
      typeList: {
        '1': this.$t('pc_biz_shoptour_offline').d('线下巡检'),
        '2': this.$t('pc_biz_shoptour_online').d('线上巡店'),
        '3': this.$t('pc_biz_shoptour_store_check').d('门店自检'),
        '4': this.$t('pc_biz_shoptour_display').d('陈列检查')
      },
      inspectionSearch: {
        types: [], // 任务类型
        searchKey: '', // 搜索关键词
        limit: 50,
        offset: 0,
        orderby: 'release_time',
        direction: 'desc',
        status: '' // 任务状态
      },
      loading: false,
      totalPage: 0,
      count: 0,
      selectedList: [],
      selected: {},
      showFilterAll: true, // 是否显示筛选所有
      isSearchAll: false,
      isCancelSelect: false
    };
  },
  created() {
    this.formatModel(this.value);
    this.getInspectionList();
  },
  methods: {
    changeOrg(org) {
      this.inspectionSearch.queryOrgId = org ? org.orgId : undefined;
      this.getInspectionList(true);
    },
    changeDate() {
      this.inspectionSearch.releaseDateStart = this.publishDate
        ? this.shortDate(null, null, this.publishDate[0])
        : '';
      this.inspectionSearch.releaseDateEnd = this.publishDate
        ? this.shortDate(null, null, this.publishDate[1])
        : '';
      this.inspectionSearch.beginDateStart = this.startDate
        ? this.shortDate(null, null, this.startDate[0])
        : '';
      this.inspectionSearch.beginDateEnd = this.startDate
        ? this.shortDate(null, null, this.startDate[1])
        : '';
      this.inspectionSearch.endDateStart = this.endDate
        ? this.shortDate(null, null, this.endDate[0])
        : '';
      this.inspectionSearch.endDateEnd = this.endDate
        ? this.shortDate(null, null, this.endDate[1])
        : '';
      this.getInspectionList(true);
    },
    changeStatus() {
      this.getInspectionList(true);
    },
    getStatusName(status) {
      let sName = this.statusList.find(item => item.value === status).label;
      return sName;
    },
    shortDate(row, col, val, index) {
      if (!val) return '--';
      if (typeof val === 'string') {
        val = val.replace(/-/g, '/');
      }
      return col && col.property === 'releaseTime' ? dateUtil.format(new Date(val), 'yyyy-MM-dd HH:mm') : dateUtil.format(new Date(val), 'yyyy-MM-dd');
    },
    getInspectionList(isReset) {
      if (isReset) {
        this.page = 1;
        this.inspectionSearch.offset = 0;
      }
      this.inspectionSearch.limit = this.limit;
      this.inspectionSearch.searchKey = this.inspectionSearch.searchKey.trim();
      const {searchKey, limit, offset, orderby, direction, status, types} = this.inspectionSearch;
      const params = {
        direction,
        limit,
        offset,
        orderby
      };
      const data = {
        releaseDateStart: this.publishDate && this.publishDate[0] ? this.shortDate(null, null, this.publishDate[0]) : '',
        releaseDateEnd: this.publishDate && this.publishDate[1] ? this.shortDate(null, null, this.publishDate[1]) : '',
        beginDateStart: this.startDate && this.startDate[0] ? this.shortDate(null, null, this.startDate[0]) : '',
        beginDateEnd: this.startDate && this.startDate[1] ? this.shortDate(null, null, this.startDate[1]) : '',
        endDateStart: this.endDate && this.endDate[0] ? this.shortDate(null, null, this.endDate[0]) : '',
        endDateEnd: this.endDate && this.endDate[1] ? this.shortDate(null, null, this.endDate[1]) : '',
        types,
        status,
        searchKey
      };
      this.loading = true;
      getInspectionList(params, data)
        .then(result => {
          // 有搜索结果展示全选筛选结果
          this.showFilterAll = result.datas.length !== 0;
          this.inspectionList = result.datas;
          this.totalPage = result.paging.pages;
          this.count = result.paging.count;
          this.loading = false;
          this.$nextTick(() => {
            this.setChecked();
          });
        })
        .catch(e => {
          this.loading = false;
          this.$message.error(e.error.message);
        });
    },
    // 选中全部筛选结果
    searchAll() {
      if (this.isCancelSelect) {
        // 取消全部筛选结果
        return this.cancelSelectAll();
      }
      if (this.selectedList.length >= this.maxCount) {
        this.$message.warning(this.$t('pc_biz_shoptour_task_limit', [this.maxCount]).d(`任务数量不能超过${this.maxCount}`));
        return;
      }
      const limitCount = this.maxCount + 1;
      const len = Math.ceil(this.count / limitCount);
      this.inspectionSearch.limit = this.limit;
      this.inspectionSearch.searchKey = this.inspectionSearch.searchKey.trim();
      const {searchKey, orderby, direction, status, types} = this.inspectionSearch;
      const data = {
        releaseDateStart: this.publishDate && this.publishDate[0] ? this.shortDate(null, null, this.publishDate[0]) : '',
        releaseDateEnd: this.publishDate && this.publishDate[1] ? this.shortDate(null, null, this.publishDate[1]) : '',
        beginDateStart: this.startDate && this.startDate[0] ? this.shortDate(null, null, this.startDate[0]) : '',
        beginDateEnd: this.startDate && this.startDate[1] ? this.shortDate(null, null, this.startDate[1]) : '',
        endDateStart: this.endDate && this.endDate[0] ? this.shortDate(null, null, this.endDate[0]) : '',
        endDateEnd: this.endDate && this.endDate[1] ? this.shortDate(null, null, this.endDate[1]) : '',
        types,
        status,
        searchKey
      };
      if (len > 0) {
        this.isSearchAll = true;
      }
      const params = {
        direction,
        limit: limitCount,
        offset: 0,
        orderby
      };
      getInspectionList(params, data)
        .then((result) => {
          this.isSearchAll = false;
          const list = result.datas;
          for (let i = 0; i < list.length; i++) {
            if (Object.values(this.selected).length >= this.maxCount) {
              this.$message.warning(this.$t('pc_biz_shoptour_task_limit_part', [this.maxCount]).d(`部分任务未被选中，因为选择的任务数量已经超过${this.maxCount}`));
              break;
            }
            this.selected[list[i].id] = list[i];
          }
          // 此处处理一页没有请求完数据的情况，加提示
          if (result.paging.pages > 1) {
            this.$message.warning(this.$t('pc_biz_shoptour_item_limit_part', [this.maxCount]).d(`部分检查项未被选中，因为选择的检查项数量已经超过${this.maxCount}`));
          }
          this.outPut();
        })
        .catch((e) => {
          this.isSearchAll = false;
          this.$message({
            type: 'error',
            message: e.message || e.error.message
          });
        });
    },
    // 取消全部筛选结果
    cancelSelectAll() {
      const {searchKey, orderby, direction, status, types} = this.inspectionSearch;
      const params = {
        direction,
        limit: this.count,
        offset: 0,
        orderby
      };
      const data = {
        releaseDateStart: this.publishDate && this.publishDate[0] ? this.shortDate(null, null, this.publishDate[0]) : '',
        releaseDateEnd: this.publishDate && this.publishDate[1] ? this.shortDate(null, null, this.publishDate[1]) : '',
        beginDateStart: this.startDate && this.startDate[0] ? this.shortDate(null, null, this.startDate[0]) : '',
        beginDateEnd: this.startDate && this.startDate[1] ? this.shortDate(null, null, this.startDate[1]) : '',
        endDateStart: this.endDate && this.endDate[0] ? this.shortDate(null, null, this.endDate[0]) : '',
        endDateEnd: this.endDate && this.endDate[1] ? this.shortDate(null, null, this.endDate[1]) : '',
        types,
        status,
        searchKey
      };
      this.isSearchAll = true;
      // 此处获取全量数据
      getInspectionList(params, data).then((res) => {
        this.isSearchAll = false;
        this.isCancelSelect = false;
        const list = res.datas;
        list.forEach((item) => {
          delete this.selected[item.id];
        });
        this.outPut();
      });
    },
    examNameSearch() {
      this.getInspectionList(true);
    },
    sortChange(sort) {
      this.inspectionSearch.direction = sort.order || 'desc';
      this.getInspectionList();
      return false;
    },
    pageChange(page) {
      this.page = page;
      this.inspectionSearch.offset = (page - 1) * this.inspectionSearch.limit;
      this.getInspectionList();
    },
    select(item, row) {
      let isAdd = item.some(v => {
        return v.id === row.id;
      });
      if (!isAdd) {
        delete this.selected[row.id];
      } else {
        if (this.selectedList.length >= this.maxCount) {
          this.$message.warning(this.$t('pc_biz_shoptour_task_limit', [this.maxCount]).d(`任务数量不能超过${this.maxCount}`));
        } else {
          this.selected[row.id] = row;
        }
      }
      this.outPut();
    },
    selectAll(items) {
      let isAdd = items.length !== 0;
      if (isAdd && this.selectedList.length >= this.maxCount) {
        this.$message.warning(this.$t('pc_biz_shoptour_task_limit', [this.maxCount]).d(`任务数量不能超过${this.maxCount}`));
      } else {
        this.inspectionList.forEach(obj => {
          if (!isAdd) {
            delete this.selected[obj.id];
          } else {
            Object.values(this.selected).length >= this.maxCount ? this.$message.warning(this.$t('pc_biz_shoptour_task_limit_part', [this.maxCount]).d(`部分任务未被选中，因为选择的任务数量已经超过${this.maxCount}`)) : this.selected[obj.id] = obj;
          }
        });
      }
      this.outPut();
    },
    deleteItem(item) {
      let row = item;
      for (let index = 0; index < this.inspectionList.length; index++) {
        const element = this.inspectionList[index];
        if (element.id === item.id) {
          row = element;
          break;
        }
      }
      if (row) {
        this.$refs['stb'].toggleRowSelection(row, false);
      }
      delete this.selected[item.id];
      this.$forceUpdate();
      this.outPut();
    },
    clear() {
      this.$refs['stb'].clearSelection();
      this.selected = {};
      this.outPut();
    },
    outPut() {
      this.selectedList = Object.values(this.selected);
      this.$emit('input', this.selectedList);
      this.$emit('select', this.selectedList);
    },
    setChecked() {
      this.inspectionList.forEach(obj => {
        if (this.selected.hasOwnProperty(obj.id)) {
          this.$refs['stb'].toggleRowSelection(obj, true);
        } else {
          this.$refs['stb'].toggleRowSelection(obj, false);
        }
      });
    },
    formatModel(v) {
      this.selected = {};
      v.forEach(obj => {
        this.selected[obj.id] = obj;
      });
      this.selectedList = Object.values(this.selected);
    }
  },
  watch: {
    value(v) {
      this.formatModel(v);
      this.setChecked();
    }
  }
};
</script>
